<template lang="pug">
.name-span.flex.align-center.gap-4
  template(v-if="showToolTip")
    el-tooltip(
      effect="dark"
      placement="top"
      :content="this.patient.information_completeness === false ? '基本資料未完整' : '尚未設定 LINE Chat ID'"
    )
      span.flex.align-center.gap-2.flex.align-center.gap-4(
        :class="{'cancel-text': isCancelled, 'danger-color': showIncompleteness, 'warn-color': showLineNotSet}")
        template(v-if="showSubType === 'statutoryagents'")
          span 法代
          span :
        template(v-else-if="showSubType === 'children'")
          span 子女
          span :
        span {{ patient.family_name }}{{ patient.given_name }}
        i.el-icon-document-copy(@click="copyName($event, patient)" v-if="!noCopy")
  template(v-else)
    span(:class="{'cancel-text': isCancelled}") {{ patient.family_name }}{{ patient.given_name }}
    i.el-icon-document-copy(@click="copyName($event, patient)" :class="{'cancel-text': isCancelled}" v-if="!noCopy")
</template>

<script>
export default {
  name: 'NameSpan',
  props: {
    patient: {
      type: Object,
      required: true,
    },
    isCancelled: {
      type: Boolean,
      default: false,
    },
    noCopy: {
      type: Boolean,
      default: false,
    },
    showSubType: {
      type: String,
      default: '',
    },
  },
  computed: {
    showToolTip() {
      return this.patient.information_completeness === false || !this.patient.line_chat_id;
    },
    showIncompleteness() {
      return this.patient.information_completeness === false;
    },
    showLineNotSet() {
      return !this.patient.line_chat_id;
    },
  },
  methods: {
    copyName(e, user) {
      e.stopPropagation();
      const name = `${user.family_name}${user.given_name}`;
      this.$copy(name, true);
      this.$showSuccess(`已複製 ${name} 到剪貼簿`);
    },
  },
};
</script>

<style lang="scss" scoped>
.name-span {
  white-space: nowrap;
}
</style>
